import React from 'react'
import { Collapse } from 'antd'
import { CardContainer } from 'components'
import { IcChevronDown } from 'assets/icons'

const ScanDiagnosticSection = () => {
  const fieldPanelStyle = 'font-medium text-gray-500'
  const panelBorderBottom = 'flex border border-solid border-b-1 border-x-0 border-t-0 border-b-gray-300 my-3 mx-4'

  return (
    <CardContainer
      minHeight="20%"
      px="px-2"
    >
      <div
        className="flex border border-solid border-b-1 border-x-0 border-t-0 border-b-gray-300 pb-4 mx-4"
      >
        <span className="font-semibold text-2xl text-gray-900">
          Scan Diagnostic
        </span>
      </div>
      <Collapse
        className="inspeksi-detail-interior pt-2"
        defaultActiveKey={[]}
        ghost
        expandIconPosition="end"
        expandIcon={(collapse) => {
          const className = collapse.isActive ? '-rotate-180' : ''
          return (
            <div>
              <IcChevronDown className={`text-gray-900 ${className}`} size={18} />
            </div>
          )
        }}
      >
        <Collapse.Panel
          header="A. Body Area Bagasi & Tools"
          key="scan-diagnostic-0"
          className="inspeksi-collapse-header font-medium text-md"
        >
          <div
            className="flex"
          >
            <span
              className={fieldPanelStyle}
            >
              Lom tau
            </span>
          </div>
        </Collapse.Panel>
        <div
          className={panelBorderBottom}
        />
        <Collapse.Panel
          header="B. Chasis & Drive Tarin Area Bagasi & Tools"
          key="scan-diagnostic-1"
          className="inspeksi-collapse-header font-medium text-md"
        >
          <div
            className="flex"
          >
            <span
              className={fieldPanelStyle}
            >
              Lom tau
            </span>
          </div>
        </Collapse.Panel>
      </Collapse>
    </CardContainer>
  )
}

export default ScanDiagnosticSection
